/**
 * Production wiring for `applyDeeplinkImpersonation` (see
 * ./deeplinkImpersonation.js). Kept apart from the decision module so that
 * module and `requireToken` stay unit-testable without Pinia, axios or
 * `window.location`; the router and the login page pass this in.
 */
import { applyDeeplinkImpersonation } from './deeplinkImpersonation'
import { getDeeplinkOwnerApi } from '@/services/impersonationService'
import { useImpersonationStore } from '@/stores/impersonation'

// sessionStorage can throw on access (storage disabled); the guard then
// degrades to "no guard", which applyDeeplinkImpersonation tolerates.
const NO_STORAGE = {
    getItem: () => null,
    setItem: () => {},
    removeItem: () => {},
}

function sessionStorageOrNone() {
    try {
        return window.sessionStorage || NO_STORAGE
    } catch (_e) {
        return NO_STORAGE
    }
}

/**
 * @param {object} route resolved route location
 * @returns {Promise<'proceed'|'landing'|'reloading'>}
 */
export function runDeeplinkImpersonation(route) {
    return applyDeeplinkImpersonation(route, {
        resolveOwner: getDeeplinkOwnerApi,
        impersonation: useImpersonationStore(),
        storage: sessionStorageOrNone(),
        // replace, not assign: the page being left is /login (after a
        // sign-in) or this same link (a page load), and neither belongs in
        // the back-button history.
        hardNavigate: (path) => window.location.replace(path),
    })
}

export default runDeeplinkImpersonation
